// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__NAEhQ","content":"styles_content__JdvYp","planet":"styles_planet__XYznu"};